export const tableColumnWidth: number = 240;
